(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('MarkDialogController', MarkDialogController);

    function MarkDialogController(logger, $uibModalInstance, $translate, notifyingService, dataService, activity) {
        var vm = this;

        vm.activity = activity;
        
        vm.approvedOptions = [
            { label: $translate.instant("yes"), value: true },
            { label: $translate.instant("no"), value: false }
        ];

        var now = new Date();

        // set defaults
        vm.datepickerIsOpen = false;
        vm.approvedDate = now;
        vm.previousApprovedDate = vm.approvedDate;
        vm.approved = vm.approvedOptions[0];

        vm.datepickerOptions = {
            showWeeks: true,
            maxDate: now
        };

        vm.cancel = cancel;
        vm.dateChange = dateChange;
        vm.openDatepicker = openDatepicker;
        vm.save = save;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function dateChange() {
            if (vm.approvedDate) {
                vm.previousApprovedDate = vm.approvedDate;
            } else {
                vm.approvedDate = vm.previousApprovedDate;
            }
        }

        function openDatepicker() {
            if (vm.datepickerIsOpen) return;
            vm.datepickerIsOpen = true;
        }

        function save() {
            return dataService
                .saveMark(activity.userQualityId, activity.groupId, activity.activityId, vm.approvedDate, vm.approved.value, vm.remark)
                .then(result => {
                    logger.success('successfully_saved');
                    $uibModalInstance.close(result);
                });
        }
    }
})();
